import { IconProps } from ".";
import { Colors } from "../../styles/colors";

const barColor = (volume: number, threshold: number): string => {
    if (threshold <= volume) {
        return Colors.darkBlue;
    }

    return "#D9D9D9";
};

const VolumeBarIcon = ({ ...props }: VolumeBarIconProps): JSX.Element => {
    return (
        <svg width="190" height="20" viewBox="0 0 190 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="10" height="20" rx="2" fill={barColor(props.volume, 0.1)} />
            <rect x="20" width="10" height="20" rx="2" fill={barColor(props.volume, 0.2)} />
            <rect x="40" width="10" height="20" rx="2" fill={barColor(props.volume, 0.3)} />
            <rect x="60" width="10" height="20" rx="2" fill={barColor(props.volume, 0.4)} />
            <rect x="80" width="10" height="20" rx="2" fill={barColor(props.volume, 0.5)} />
            <rect x="100" width="10" height="20" rx="2" fill={barColor(props.volume, 0.6)} />
            <rect x="120" width="10" height="20" rx="2" fill={barColor(props.volume, 0.7)} />
            <rect x="140" width="10" height="20" rx="2" fill={barColor(props.volume, 0.8)} />
            <rect x="160" width="10" height="20" rx="2" fill={barColor(props.volume, 0.9)} />
            <rect x="180" width="10" height="20" rx="2" fill={barColor(props.volume, 1)} />
        </svg>
    );
};

interface VolumeBarIconProps extends IconProps {
    volume: number;
}

export default VolumeBarIcon;
